import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'



const SideBar = (props) => {

    const {onClick, value} = props;
    
    return (
        <Fragment>

            {/* slide-bar start */}
            <aside className={value?"slide-bar show":"slide-bar"}>
                <div className="close-mobile-menu">
                    <a href="#" onClick={onClick}>
                        <i className="fas fa-times"/>
                    </a>
                </div>
                {/* offset-sidebar start */}
                <div className="offset-sidebar">
                    <div className="offset-widget offset-logo mb-30">
                        <Link to="/" aria-label="CODAM 홈">
                            <img src="/assets/img/logo/codam-logo.svg" alt="CODAM 로고" style={{maxHeight: '42px', width: 'auto'}} />
                        </Link>
                    </div>
                    <div className="offset-widget mb-40">
                        <div className="info-widget">
                            <h4 className="offset-title mb-20">{'\uCF54\uB2F4 \uC18C\uAC1C'}</h4>
                            <p className="mb-30">
                                {'\uD55C\uAD6D \uAE30\uC5C5\uC758 \uB514\uC9C0\uD138 \uACBD\uC7C1\uB825\uC744 \uB192\uC774\uB294 \uD504\uB9AC\uBBF8\uC5C4 \uC5D4\uD130\uD504\uB77C\uC774\uC988 IT \uC194\uB8E8\uC158 \uD30C\uD2B8\uB108\uC785\uB2C8\uB2E4.'}
                                {'\uC6F9 \uD50C\uB7AB\uD3FC, AI \uC2DC\uC2A4\uD15C, \uD074\uB77C\uC6B0\uB4DC \uC778\uD504\uB77C, \uC0AC\uC774\uBC84 \uBCF4\uC548\uAE4C\uC9C0 \uD568\uAED8\uD569\uB2C8\uB2E4.'}
                            </p>
                        </div>
                    </div>
                    <div className="offset-widget mb-30 pr-10">
                        <div className="info-widget info-widget2">
                            <h4 className="offset-title mb-20">{'\uC5F0\uB77D\uCC98'}</h4>
                            <p>
                                <i className="fal fa-address-book"/>
                                {'\uACBD\uAE30\uB3C4 \uC131\uB0A8\uC2DC \uBD84\uB2F9\uAD6C \uD310\uAD50\uC5ED\uB85C192\uBC88\uAE38 16, 8\uCE35 806\uD638'}</p>
                            <p>
                                <i className="fal fa-clock"/>
                                {'\uD3C9\uC77C 09:00 \u2013 18:00'}
                            </p>
                            <p>
                                <i className="fal fa-envelope-open"/>
                                contact@codam.co.kr
                            </p>
                        </div>
                    </div>
                    <div className="login-btn text-center">
                        <Link className="theme_btn w-100" to="/contact">{'\uBB38\uC758\uD558\uAE30'}</Link>
                    </div>
                </div>
                {/* offset-sidebar end */}
            </aside>
            {/* slide-bar end */}
        </Fragment>
    )
}

export default SideBar